export const AU_STATE_CODES = [
  'ACT',
  'NSW',
  'NT',
  'QLD',
  'SA',
  'TAS',
  'VIC',
  'WA'
]

export const formatStateForUrl = (state: string): string =>
  state.replace(/\s+/g, '-').toLowerCase()

export const stateSegmentToCode = (
  segment: string,
  tabItems?: string[]
): string | null => {
  const segmentLower = segment.toLowerCase()

  const directMatch = AU_STATE_CODES.find(
    code => formatStateForUrl(code) === segmentLower
  )
  if (directMatch) return directMatch

  if (tabItems?.length) {
    const matchedTab = tabItems.find(
      tab => formatStateForUrl(tab) === segmentLower
    )
    if (matchedTab) return matchedTab
  }

  return null
}

export const parseGymsStateFilter = (
  slug: string | string[]
): { stateCode: string; baseSlug: string } | null => {
  const slugStr = Array.isArray(slug) ? slug.join('/') : String(slug)
  const parts = slugStr.split('/').filter(Boolean)

  if (parts.length !== 2 || parts[0] !== 'gyms') return null

  const stateCode = stateSegmentToCode(parts[1])
  if (!stateCode) return null

  return { stateCode, baseSlug: 'gyms' }
}

export const getStateFromGymsPath = (
  asPath: string,
  tabItems?: string[]
): string => {
  const path = asPath.split('?')[0].split('#')[0]
  const match = path.match(/^\/gyms\/([^/]+)\/?$/)
  if (!match) return ''

  return stateSegmentToCode(match[1], tabItems) || ''
}
